"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeedBack = void 0;
var react_1 = __importStar(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
require("./index.less");
var lodash_1 = require("lodash");
// declare var document: Document
/**
 * 右侧意见反馈及返回顶部组件
 */
function FeedBack(props) {
    var ref_feed = (0, react_1.useRef)(null);
    var ref_top = (0, react_1.useRef)(null);
    var _a = (0, react_1.useState)(false), showgotop = _a[0], setShowGotop = _a[1];
    // let [mleft,setMarginLeft] = useState("")
    (0, react_1.useEffect)(function () {
        $(window).scroll((0, lodash_1.throttle)(function () {
            if ($(document).scrollTop() >= 300) {
                setShowGotop(true);
            }
            else {
                setShowGotop(false);
            }
        }, 500));
    }, []);
    var enterFeedback = function () {
        var curdom = $(ref_feed.current);
        $("span", curdom).hide();
        $(".feedback-left", curdom).show().animate({ left: "12px" }, 250);
        $(".feedback-right", curdom).show().animate({ left: "24px" }, 250);
    };
    var leaveFeedback = function () {
        var curdom = $(ref_feed.current);
        $("span", curdom).show();
        $(".feedback-left", curdom).hide().css({ left: "-36px" });
        $(".feedback-right", curdom).hide().css({ left: "50px" });
    };
    var enterGotop = function () {
        $(ref_top.current).removeClass("icon-gotop").text("返回顶部");
    };
    var leaveGotop = function () {
        $(ref_top.current).addClass("icon-gotop").text("");
    };
    return react_dom_1.default.createPortal(react_1.default.createElement("div", { className: "qt_feedback" },
        react_1.default.createElement("a", { onMouseEnter: function () { enterFeedback(); }, onMouseLeave: function () { leaveFeedback(); }, ref: ref_feed, className: "feedback", href: "http://corp.eastmoney.com/liuyan.html", target: "_blank" },
            react_1.default.createElement("span", null, "\u610F\u89C1\u53CD\u9988"),
            react_1.default.createElement("div", { className: "feedback-left", style: { display: "none" } }),
            react_1.default.createElement("div", { className: "feedback-right", style: { display: "none" } })),
        showgotop && react_1.default.createElement("a", { ref: ref_top, onMouseEnter: function () { enterGotop(); }, onMouseLeave: function () { leaveGotop(); }, className: "gotop icon-gotop", onClick: function (e) { e.preventDefault(); $(document).scrollTop(0); return false; } })), document.body);
}
exports.FeedBack = FeedBack;
